import { render, staticRenderFns } from "./CountByApplyDocResearcherRegionOrgComponent.vue?vue&type=template&id=131d9425&scoped=true&"
import script from "./CountByApplyDocResearcherRegionOrgComponent.vue?vue&type=script&lang=js&"
export * from "./CountByApplyDocResearcherRegionOrgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d9425",
  null
  
)

export default component.exports